const initMenu = (menu) => {
    const mobileToggle = menu.querySelector('.menu__mobile-toggle');
    if (mobileToggle) {
        mobileToggle.addEventListener('click', () => menu.classList.toggle('open'));
    }
    window.addEventListener('pageChange', () => {
        menu.classList.toggle('open', false);
    });
};
export const initMenus = () => {
    document.querySelectorAll('.menu').forEach((menu) => initMenu(menu));
};
